import React, {useRef,useEffect, useState} from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import style from './CreateGroupComStyle.module.scss';
import {useMessage} from "../../hooks/message.hook";
import NewsService from "../../services/NewsService";

function EditGroupCom({news, setActivemodal}) {
    const coms = [
        {
            name: 'OMEDIA!',
            active: false
        },
        {
            name: 'HOPE KIDS',
            active: false
        },
        {
            name: 'REA FARM',
            active: false
        },
        {
            name: 'HOPE FITNESS',
            active: false
        },
        {
            name: 'ТРАЕКТОРИЯ НАДЕЖДЫ',
            active: false
        },
        {
            name: 'СУРГУТ 24',
            active: false
        },
        {
            name: 'ВЕРНЫЙ ДРУГ',
            active: false
        },
        {
            name: 'THE KITCHA',
            active: false
        },
        {
            name: 'OMEDIA!',
            active: false
        }
    ]
    const message = useMessage();
    const [publiccom, setPubliccom] = useState(coms)

    const [viewcom, setViewcom] = useState()

    const onoffActive = (index) => {
        const newarr = [...viewcom]
        newarr[index].active = !newarr[index].active
        setViewcom(newarr)
    }

    const post = []

    const [view, setView] = useState(post);
    const [namepost, setNamepost] = useState('');
    const [descpost, setDescpost] = useState('');
    const [textpost, setTextpost] = useState('');
    const [urlsite, setUrlsite] = useState('');
    const fileInputRef = useRef(null);
    const fileInputRefLogo = useRef(null);
    const [imgpage, setImgpage] = useState('');
    const [imglogo, setImglogo] = useState('');
    const [newContact1, setnewContact1] = useState('')
    const [newContact2, setnewContact2] = useState('')
    const [newContact3, setnewContact3] = useState('')
    const [listContact1, setlistContact1] = useState(['velfr','мудак'])
    const [listContact2, setlistContact2] = useState([])
    const [listContact3, setlistContact3] = useState([])
    const [numposition, setNumposition] = useState(0)

    const createGroupCom = async () => {
        try{
            const id = news.id
            const name = namepost
            const desc = descpost
            const contacts = listContact1
            const contacts2 = listContact2
            const contacts3 = listContact3
            const site = urlsite
            const logo = imglogo
            const img = imgpage
            const number = numposition

            const {data} = await NewsService.editСomGroup({id,name,desc,contacts,contacts2,contacts3,site,logo,img,number})
            if(data){
                setActivemodal(false)
                message(`О! ${namepost} успешно Изменено`)
                setNamepost('')
                setDescpost('')
                setUrlsite('')
                setImgpage('')
                setImglogo('')
                setlistContact1([])
                setlistContact2([])
                setlistContact3([])
                setNumposition(0)
            }

        }catch(e){
            console.log(e)
            setActivemodal(false)
            message(`Что-то пошло не так попробуйте снова`)
        }
    }
    useEffect(()=>{
        console.log(imgpage)
    }, [imgpage])
    const handleFileUpload = (event) => {
        const formData = new FormData();
        formData.append('image', event.target.files[0]);

        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/upload`, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setImgpage(data.filePath);
            })
            .catch(error => console.error('Error uploading image:', error));
    };

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileUploadLogo = (event) => {
        const formData = new FormData();
        formData.append('image', event.target.files[0]);

        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/upload`, {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setImglogo(data.filePath);
            })
            .catch(error => console.error('Error uploading image:', error));
    };

    const handleClickLogo = () => {
        if (fileInputRefLogo.current) {
            fileInputRefLogo.current.click();
        }
    };

    const deletContact1 = index => {
        const newarr = [...listContact1]
        newarr.splice(index, 1)
        setlistContact1(newarr)
    }
    const deletContact2 = index => {
        const newarr = [...listContact2]
        newarr.splice(index, 1)
        setlistContact2(newarr)
    }
    const deletContact3 = index => {
        const newarr = [...listContact3]
        newarr.splice(index, 1)
        setlistContact3(newarr)
    }

    const plusContact1 = () => {
        const newarr = [...listContact1]
        if(newContact1.length>0){
            newarr.push(newContact1)
            setlistContact1(newarr)
            setnewContact1('')
        }else{
            message('Введите контакт')
        }
    }
    const plusContact2 = () => {
        const newarr = [...listContact2]
        if(newContact2.length>0){
            newarr.push(newContact2)
            setlistContact2(newarr)
            setnewContact2('')
        }else{
            message('Введите контакт')
        }
    }
    const plusContact3 = () => {
        const newarr = [...listContact3]
        if(newContact3.length>0){
            newarr.push(newContact3)
            setlistContact3(newarr)
            setnewContact3('')
        }else{
            message('Введите контакт')
        }
    }

    useEffect(()=>{
        setViewcom(coms)
        setNamepost(news.name)
        setDescpost(news.desc)
        setImgpage(news.image)
        setImglogo(news.logo)
        setUrlsite(news.site)
        if(news){
            setlistContact1(news.contacts)
            setlistContact2(news.contacts2)
            setlistContact3(news.contacts3)
        }

        setNumposition(+news.number)
    }, [news])
    return (
        <DndProvider backend={HTML5Backend}>
            <div className={style.main}>
                <div className={style.left}>
                    <div className={style.nameblock} style={{justifyContent: 'center', textAlign:'center', marginBottom: '20px'}}>Загрузите логотип компании</div>
                    <div
                        className={style.photo}
                        onClick={handleClickLogo}
                        style={(imglogo && imglogo.length>0)?{backgroundImage: `url('${imglogo}')`}:{backgroundImage: `url('/files/news/nophoto.svg')`}}>
                        <div className={style.active}><i className="fa-solid fa-plus"/></div>
                    </div>
                    <input
                        type="file"
                        ref={fileInputRefLogo}
                        style={{ display: 'none' }}
                        onChange={handleFileUploadLogo}
                        accept="image/*"
                    />
                    <div className={style.bottom}>
                        <div className={style.numposition}>
                            <div className={style.textpos}>Позиция в списке:</div>
                            <input className={style.numpos} value={numposition} onChange={(e)=>setNumposition(e.target.value)}/>
                        </div>
                        <div className={style.saving} onClick={createGroupCom}>
                            <i className="fa-regular fa-floppy-disk"/>
                            <div className={style.text}>Сохранить</div>
                        </div>
                    </div>
                </div>

                <div className={style.center}>
                    <div
                        className={style.photo}
                        onClick={handleClick}
                        style={(imgpage && imgpage.length>0)?{backgroundImage: `url('${imgpage}')`}:{backgroundImage: `url('/files/news/nophoto.svg')`}}>
                        <div className={style.active}><i className="fa-solid fa-plus"/></div>
                    </div>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileUpload}
                        accept="image/*"
                    />
                    <br/>
                    <div className={style.nameblock}>Название компании</div>
                    <input className={style.title} value={namepost} onChange={(e)=>setNamepost(e.target.value)}/>
                    <br/>
                    <div className={style.nameblock}>Краткое описание новости</div>
                    <textarea className={style.desc} value={descpost} onChange={(e)=>setDescpost(e.target.value)}></textarea>
                    <br/>
                    <div className={style.nameblock}>URL (ссылка)</div>
                    <input className={style.title} value={urlsite} onChange={(e)=>setUrlsite(e.target.value)} placeholder='Укажите ссылку на сайта'/>
                </div>

                <div className={style.right}>
                    <div className={style.up}>
                        <div className={style.title}>Контакты 1:</div>
                        <input className={style.titleinput} value={newContact1} onChange={(e)=>setnewContact1(e.target.value)}/>
                        <div className={style.btnplus} onClick={plusContact1}>Добавить</div>
                        <div className={style.listcom}>
                            {listContact1.map((contact, indexcontact)=>(
                                <div key={indexcontact} className={style.contactlist}>{contact} <i className="fa-solid fa-trash" onClick={()=>deletContact1(indexcontact)}/></div>
                            ))}
                        </div>
                    </div>
                    <div className={style.up}>
                        <div className={style.title}>Контакты 2 :</div>
                        <input className={style.titleinput} value={newContact2} onChange={(e)=>setnewContact2(e.target.value)}/>
                        <div className={style.btnplus} onClick={plusContact2}>Добавить</div>
                        <div className={style.listcom}>
                            {listContact2.map((contact, indexcontact)=>(
                                <div key={indexcontact} className={style.contactlist}>{contact} <i className="fa-solid fa-trash" onClick={()=>deletContact2(indexcontact)}/></div>
                            ))}
                        </div>
                    </div>
                    <div className={style.up}>
                        <div className={style.title}>Контакты 3:</div>
                        <input className={style.titleinput} value={newContact3} onChange={(e)=>setnewContact3(e.target.value)}/>
                        <div className={style.btnplus} onClick={plusContact3}>Добавить</div>
                        <div className={style.listcom}>
                            {listContact3.map((contact, indexcontact)=>(
                                <div key={indexcontact} className={style.contactlist}>{contact} <i className="fa-solid fa-trash" onClick={()=>deletContact3(indexcontact)}/></div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </DndProvider>
    );
}

export default EditGroupCom;